<template>
<div class="screen" ref="screen">
  <!-- 大屏头部 -->
  <div class="header-top"><!-- @click="tempV()" -->
    <div class="title">{{systemName}}</div>
    <div class="header-left">
      <span>{{headerTop.date}}</span>
      <span>{{headerTop.week}}</span>
      <span>{{headerTop.time}}</span>
      <el-tooltip class="item" effect="dark" :content="isOnline ? '通信正常：通信正常情况下，能正常接收报警信息。' : '通信断开：通信断开情况下，无法正常接收报警信息！请刷新重试或联系管理员！'" placement="bottom">
        <p :class="isOnline ? 'normal' : 'abNormal'"><i></i>{{isOnline ? '通信正常' : '通信断开'}}</p>
      </el-tooltip>
    </div>
    <div class="header-right">
      <p class="myIcon el-icon-refresh" title="刷新当前页面" @click="handleReload"></p>
      <p class="myIcon el-icon-warning-outline" @click="handleAttention"></p>
      <!-- <el-tooltip class="item" effect="dark" content="测试语音是否能正常播放！" placement="bottom">
        <p class="voice" @click="testVoice"><img src="./../../assets/img/bigScreen/voice.png" alt=""> 测试声音</p>
      </el-tooltip> -->

      <el-popover placement="bottom" width="300" trigger="click">
        <div class="screen-test-box">
          <el-switch
            v-model="isMp3"
            @change="handleVoice"
            active-color="#13ce66"
            inactive-color="#02D9FD"
            active-text="警报声"
            inactive-text="语音播报">
          </el-switch>
          <p>提示: 【语音播报】功能只支持部分浏览器，如果您的浏览器不支持，建议切换至【报警声】功能</p>
        </div>
        <p class="voice" slot="reference"><img src="./../../assets/img/bigScreen/voice.png" alt=""> 音效切换</p>
      </el-popover>

      <p class="alarm-switch">
        <el-switch v-model="AlarmSwitch" active-color="rgba(2, 217, 253, 0.5)" inactive-color="rgba(0,0,0,0)" @change="handleChangeAlarm" />
        <span>报警</span>
      </p>
      <p @click="toBack">
        <i class="el-icon-menu" title="后台" @click="toBack"></i> 后台
      </p>
      <p @click="logOut()">
        <i class="el-icon-switch-button"></i> 退出
      </p>
      <div class="p-div">
        <p class="alarm-box">
          <!-- <img src="../../assets/img/bigScreen/alarm.gif" alt="" v-show="isVoice"> -->
          <!-- <audio ref="audio" src="../../assets/img/bigScreen/alarm.mp3"></audio> -->
        </p>
      </div>
      <!-- <i @click="logOut()" title="退出" class="el-icon-switch-button"></i>
      <i class="el-icon-s-tools" title="后台" @click="toBack"></i> -->
    </div>
  </div>

  <!-- 中间统计数据 -->
  <ul class="total-center">
    <li v-for="(item, i) in centerPars" :key="i" @click="handleClickGo(i)">
      <img :src="item.icon" />
      <div :class="['right', `ponter${i}`]">
        <p>{{item.label}}</p>
        <!-- <p
          class="num"
          :style="{color: item.color,fontSize: item.number < 99999 ? '22px' : item.number < 999999 ? '18px' : '16px'}"
        >{{item.number > 9999999 ? '999999+' : item.number}}</p> -->
        <p
          class="num"
          :style="{color: item.color,fontSize: item.number < 99999 ? '22px' : item.number < 999999 ? '18px' : '16px'}"
        >
          <span v-if="item.number > 9999999">999999+</span>
          <rollNumber v-else :num="item.number" />
        </p>
      </div>
    </li>
  </ul>

  <!-- <div class="space"></div> -->
  <!-- 地图 -->
  <!-- <div id="map_container"></div> -->
  <!-- <img
    style="position: absolute;top:45%;left:50%;z-index:99"
    src="../../assets/img/bigScreen/loading.gif" alt=""
    v-show="isMap"
  > -->
  <div class="loading" v-show="isMap" style="position: absolute;top:35%;left:50%;z-index:99">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
  <div id="map_box"></div>

  <!-- 左侧卡片 -->
  <div class="echartsLeft">
    <div class="item" v-for="item in leftEcharts" :key="item.id">
      <div class="chartItemBox">
        <h4>{{item.name}}</h4>
        <component :is="item.componentName"></component>
      </div>
      <!-- <span class="btn" @click="openBigScreen(item.id)"><i class="el-icon-rank"></i></span> -->
    </div>
  </div>
  <!-- 右侧卡片 -->
  <div class="echartsRight">
    <div class="item" v-for="item in rightEcharts" :key="item.id">
      <div class="chartItemBox">
        <h4>{{item.name}}</h4>
        <component :is="item.componentName"></component>
      </div>
      <!-- <span class="btn" @click="openBigScreen(item.id)"><i class="el-icon-rank"></i></span> -->
    </div>
  </div>

  <!-- 地图-图层切换 -->
  <ul class="map-change" v-show="isShowChange">
    <li
      v-for="(item, i) in mapChangeData"
      :class="i == mapActive ? 'active' : ''"
      @click="handleChangeMap(i)"
      :key="i">{{item}}</li>
  </ul>

  <!-- 地图-信息窗体 -->
  <div ref="info_window"
    style="display: none;"
    :class="['info-window', infoWindowBg]"
    >
    <div class="box">
      <h4>
        <span>{{infoData.name}}</span>
        <i class="close el-icon-close" @click="handleCloseInfoWindow"></i>
      </h4>
      <p>
        <span>IMEI：</span>
        <span>{{infoData.imei}}</span>
      </p>
      <p class="orgName">
        <span>区域：</span>
        <span>{{infoData.orgName}}</span>
      </p>
      <p class="position">
        <span>安装位置：</span>
        <span>{{infoData.installLocation}}</span>
      </p>
      <p>
        <span>安装时间：</span>
        <span>{{infoData.installTime}}</span>
      </p>
      <p>
        <span>注册时间：</span>
        <span>{{infoData.registTime}}</span>
      </p>
      <p>
        <span>设备类型：</span>
        <span>{{infoData.typeName}}</span>
      </p>
    </div>
  </div>

  <!-- 报警弹框 -->
  <ul class="alarm-list" v-show="isAlarmShow"><!--  animate__shakeX animate__bounceInRight -->
    <li class="alarm-item" v-for="(item, i) in alarmList" :key="`${item.alarmId}_${i}`">
      <div class="item">
        <h4>
          <span>报警通知</span>
          <i class="close el-icon-close" @click.stop="handleCloseAlarm(i)"></i>
        </h4>
        <p>
          <span>报警内容: </span><span>{{item.content}}</span>
        </p>
        <p>
          <!-- <span>报警位置: </span><span>{{item.installLocation}}</span> -->
          <span>区域: </span><span>{{item.regionName}}</span>
        </p>
        <div class="btn-box">
          <span @click="handleShowBox(item)">地图</span>
          <span @click="handleShowDealBox(item, i)">处理</span>
        </div>
      </div>
    </li>
  </ul>

  <!-- 处理报警弹窗 -->
  <el-dialog title="处理报警" :visible.sync="isDealalarmShow" width="580px" custom-class="deal-dialog" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="formRules" label-position="right" label-width="80px">
      <el-form-item label="报警内容" prop="content">
        <el-input style="color:#999" type="textarea" v-html="policeContent"></el-input>
      </el-form-item>
      <el-form-item label="处理类型" prop="type">
        <el-select v-model="form.type" placeholder="请输入处理类型" clearable>
          <el-option v-for="(item,i) in dealType" :key="i" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理描述" prop="describe">
          <el-input type="textarea" v-model="form.describe" placeholder="请输入处理描述" maxlength="100"></el-input>
      </el-form-item>
    </el-form>
    <div class="drawerFoot">
      <el-button type="primary" @click="confirmHandle()" :loading="loadingDeal">{{ loadingDeal ? '提交中' : '提交' }}</el-button>
      <el-button @click="cancelHandle()">取 消</el-button>
    </div>
  </el-dialog>

  <!-- 报警摄像头 -->
  <ul class="video-list" ref='ul' v-show="isVideo">
    <li
      class="video-box"
      v-for="(video,index) in videoItemConfig"
      :ref="`li_${video.videoId}`"
      @mousedown="handleMousedown($event, video.videoId)"
      :key="video.videoId">
      <div class="video-box-item" :id="video.videoContainerId">
        <div class='noVideo'><i class="el-icon-video-camera iconbofang"></i><span class='noVideoText'>无播放视频</span></div>
      </div>
      <h5>联动摄像头{{index}}</h5>
      <i class="el-icon-circle-close icon-close" @click="destorySinglePlayer(index)"></i>
    </li>
  </ul>

  <!-- 注意事项 -->
  <el-dialog
    title="注意事项"
    :visible.sync="isShowAttention"
    width="800px">
    <div class="attention-box">
      <p><i class="el-icon-warning"></i>由于浏览器的安全限制，无法主动播放告警声音，因此建议用户可通过以下设置，让其自动播放声音！</p>
      <img src="./../../assets/img/bigScreen/attention.jpg" alt="">
    </div>
  </el-dialog>

  <!-- 强制修改密码 -->
  <el-dialog class="editPwdDialog" title="修改密码" :visible.sync="editPwdDialog" center :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="600px"><!--  @closed="editPwdDialogClose" -->
    <h3 class="editPwdDialogTitle"><i class="el-icon-warning-outline"></i>尊敬的用户，为了加强对数据安全的保护，需定期对密码进行修改，请修改密码，新密码要求包含【1.密码必须包含大小写字母、数字、特殊字符(!@#$%^&+=_)且密码不少于八位；2.密码不能含有相同字符（例如111、aaa）连续3位或3位以上；3.密码禁止设置递增的字母或数字（例如abc,123）连续3位或3位以上!；4.密码不能含有标准键相邻按键组合（例如ASDFG,QWERTY）】，由此给您带来不便，敬请谅解！</h3>
    <div class="tenantInfoForm">
      <el-form :model="editPwdform" class="editPwdform" ref="editPwdform" :rules="editPwdformRules">
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="editPwdform.newPassword" placeholder="请输入新密码" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPasswordConfirm">
          <el-input v-model="editPwdform.newPasswordConfirm" placeholder="请再次输入新密码" type="password" show-password></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="editPwdRequire" @click="editPwdConfirm" icon="el-icon-lock">修改密码</el-button>
    </div>
  </el-dialog>
  <!-- 强制修改密码 end -->

  <big-screen-echarts v-if="bigScreenEcharts.show" :bigScreenEcharts="bigScreenEcharts" @closeDialog="closeDialog"></big-screen-echarts>
</div>
</template>

<script>
import { chinaPly } from '@/assets/json/ChinaPly.json'
import rollNumber from '@/components/rollNumber.vue'
import markerMixin from '@/mixins/markerData.js'
import wsMixin from '@/mixins/ws.js'
import setPwd from '@/mixins/setPwd.js'
export default {
  components: {
    rollNumber,
    BigScreenEcharts: () => import('@/components/firstPage/BigScreenEcharts'),
    com1: () => import('@/components/firstPage/DeviceEcharts'),
    com2: () => import('@/components/firstPage/DangerEcharts'),
    com3: () => import('@/components/firstPage/AangerEcharts'),
    com4: () => import('@/components/firstPage/BangerEcharts'),
    com5: () => import('@/components/firstPage/CangerEcharts'),
    com6: () => import('@/components/firstPage/EangerEcharts'),
    com7: () => import('@/components/firstPage/FangerEcharts'),
    com8: () => import('@/components/firstPage/GangerEcharts'),
    com9: () => import('@/components/firstPage/HangerEcharts'),
    com10: () => import('@/components/firstPage/RepairEcharts'),
    com11: () => import('@/components/firstPage/AlarmEcharts'),
    com12: () => import('@/components/firstPage/fireFacEcharts'),
  },
  mixins: [wsMixin, setPwd, markerMixin],
  data() {
    return {
      policeContent: '',
      isWin7: true,
      isVoice: false,
      loadingDeal: false,
      isDealalarmShow: false,
      isShowAttention: false,
      alarmId: null,
      alarmIndex: null,
      // isOnline: true,
      bigScreenEcharts: {
        show: false,
        item: {}
      },
      AlarmSwitch: true,
      items: [],
      btnShow: true,
      centerPars: [
        {
          label: "安装总数",
          color: '#02D9FD',
          number: 0,
          icon: require('../../assets/img/bigScreen/total-num.png')
        },
        {
          label: "在线设备",
          color: '#02D9FD',
          number: 0,
          icon: require('../../assets/img/bigScreen/total-lineDev.png')
        },
        {
          label: "今日新增",
          color: '#08C091',
          number: 0,
          icon: require('../../assets/img/bigScreen/total-dayAdd.png')
        },
        {
          label: "今日报警",
          color: '#FA0101',
          number: 0,
          icon: require('../../assets/img/bigScreen/total-dayAlarm.png')
        },
        {
          label: "今日故障",
          color: '#FFCE38',
          number: 0,
          icon: require('../../assets/img/bigScreen/tatal-dayDefault.png')
        },
        {
          label: "异常设备",
          color: '#FFCE38',
          number: 0,
          icon: require('../../assets/img/bigScreen/tatal-dayFault.png')
        },
      ],
      mapType: '',
      satellite: null,
      chiaData: chinaPly,
      /*   mapDialog: [{
            iconColor: "#51AAA2",
            icon: "el-icon-s-flag",
            label: "管理方",
            value: '稷东派出所烟感'
          },
          {
            iconColor: "#E7A485",
            icon: "el-icon-position",
            label: "安装位置",
            value: '加薪服饰'
          },
          {
            iconColor: "#DCBE75",
            icon: "el-icon-location-information",
            label: "地址",
            value: '加薪服饰'
          },
          {
            iconColor: "#8B966C",
            icon: "el-icon-time",
            label: "安装时间",
            value: '2020-05-19 11:03:25'
          },
          {
            iconColor: "#379D94",
            icon: "el-icon-video-play",
            label: "开卡时间",
            value: '2020-05-19 11:03:25'
          },
          {
            iconColor: "#75A6BB",
            icon: "el-icon-video-pause",
            label: "结卡时间",
            value: '2020-05-19 11:03:25'
          },
        ], */
      systemName: '',
      markerList: [],
      newVal: '',
      alarmType: '',
      position: '',
      headerTop: {
        date: '',
        week: '',
        time: ''
      },
      timer: null,
      myMap: null,
      infoData: {
        userName: '--',
        orgName: '--',
        installLocation: '--',
        imei: '--',
        installTime: '--',
        registTime: '--',
        typeName: '--',
      },
      infoItem: null, // 信息窗体对象
      mapChangeData: ['卫星', '地图'],
      mapActive: 1,
      isShowChange: false,
      // alarmList: [],
      // ws: null,
      // isAlarmShow: true,
      // speecher: null,
      isMap: false,
      infoWindowBg: 'blue',
      // heartCheck:{},
      // audio: null,
      // 视频实例初始化配置数据 容器id videoid
      videoItemConfig: [
        // {
        //   videoContainerId: 'videoContainer0',
        //   videoId: 'video0',
        // }
      ],
      isVideo: false,
      i: 0,
      isDown: false,
      dragObj: {
        x: 0,
        y: 0,
        l: 0,
        t: 0
      },
      flag: 0,
      form: {
        type: null,
        describe: null
      },
      dealType: [
        { value: '1', label: '误报' },
        { value: '2', label: '真实报警' },
        { value: '3', label: '故障' },
        { value: '4', label: '测试' },
        { value: '5', label: '其他' },
      ],
      formRules: {
        type: [{ required: true, message: "请选择处理类型", trigger: 'blur' }],
        describe: [{ required: true, message: "处理描述不能为空", trigger: 'blur' }],
      },
      markerPage: {
        page: 1,
        total: 0
      },
      chunks: [],
      loginName: ''
    }
  },
  watch: {
    mapDatas(curval, oldval) {
      // console.log(curval);
      let loginName = this.loginName == 'jlhw'
      if (loginName) {
        this.getMarkerJLHW().then(res => this.processInBatchesAsync())
      } else {
        this.getMarker().then(res => this.setMarkerInMap())
      }

      // this.request.post('/front/device/deviceMapData').then(res => {
      //   console.log(res.data);

      //   if (res.code == 200) {
      //     this.markerList = res.data
      //     let obj = {}
      //     this.markerList.forEach(item => {
      //       if (item.id == curval.deviceId) {
      //         obj = Object.assign({}, item)
      //       }
      //     })
      //     let lonlg = obj.installGps
      //     if (lonlg) {
      //       // this.initMap(this.position, lonlg.split(',')[0], lonlg.split(',')[1], 'Alarm')
      //     }
      //   } else if (res.code == 500) {
      //     this.mag.warn(res.msg)
      //   }
      // })
    }
  },
  mounted() {

    this.loginName = localStorage.getItem('loginName') ?? ''
    // let OS = this.detectOS()
    // console.log(123132, OS)
    // this.isWin7 = OS == 'Win7'
  },
  created() {
    // 注意事项，第一次在浏览器打开时展示
    let isShowAttention = window.localStorage.getItem('isShowAttention')
    if (!isShowAttention) {
      this.isShowAttention = true
      window.localStorage.setItem('isShowAttention', 'show')
    }

    this.init()

    // 20分钟请求一次，防止session过期
    this.getSession()
    this.timmer = setInterval(() => {
      this.getSession()
    }, 1200 * 1000)
  },
  destroyed() {
    this.timer && clearInterval(this.timer)
    this.timer1 && clearInterval(this.timer1)
  },
  computed: {
    leftEcharts() {
      return this.items.filter((item, i) => i < 3)
    },
    rightEcharts() {
      return this.items.filter((item, i) => i > 2)
    },
    mapDatas() {
      return this.$store.state.mapData;
    },
  },
  methods: {
    getSession () {
      this.request.post('/front/api/session/rolsession')
    },
    /**
     * @Description 初始化信息请求
     * @Author      YOYO     -             2021-11-23
     */
    init() {
      // 获取左右卡片列表
      this.getChooseConfig()
      // 地图中间顶部统计数据
      this.getStaticData()

      /* 安前宾让去掉 2022-07-26 16:09:30 */
      /* 风险: session会过期 */
      // this.timer1 = setInterval(() => {
      //   this.getStaticData()
      // }, 50000)

      // 获取系统设置信息
      this.getAreaId()

      // 顶部左上角时间信息
      this.TimeInit()
      this.timer = setInterval(() => {
        this.TimeInit()
      }, 5000)
    },

    /**
     * @Description 顶部左上角时间信息
     * @Author      YOYO - 2021-11-23
     */
    TimeInit() {
      let date = new Date()

      let yy = date.getFullYear()

      let mm = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1

      let dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      let hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()

      let mf = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()

      let weekArr = ['日', '一', '二', '三', '四', '五', '六']
      let weekIndex = date.getDay()

      this.headerTop = {
        date: `${yy}-${mm}-${dd}`,
        week: `星期${weekArr[weekIndex]}`,
        time: `${hh}:${mf}`
      }

    },

    handleClickGo (i) {
      console.log(i)
      if (i == 5) {
        this.$router.push("/abnormalRecord")
      }
    },
    /**
     * @Description 地图中间顶部统计数据
     * @Author      YOYO     -             2021-11-23
     * @return      {[type]} [description]
     */
    async getStaticData() {
      const { code, msg, data } = await this.request.post('/front/device/deviceOverallStatistics')
      if (code !== 200) {
        if (code == 500) {
          return this.$message.error(msg)
        }
        return
      }
      let { onlineCount, totalCount, installCount, alarmCount, faultCount, notEnableCount } = data
      // console.log(data)
      this.centerPars[0].number = totalCount
      this.centerPars[1].number = onlineCount
      this.centerPars[2].number = installCount
      this.centerPars[3].number = alarmCount
      this.centerPars[4].number = faultCount
      this.centerPars[5].number = notEnableCount

    },

    // 获取左右卡片列表
    async getChooseConfig() {
      const { code, msg, data } = await this.request.get('/front/homepage/findTemplateByIds')
      if (code !== 200) {
        if (code == 500) {
          return this.$message.error(msg)
        }
        return
      }
      this.items = data
    },

    /**
     * @Description 获取系统设置信息
     * @Author      未知     -             2021-11-23
     */
    async getAreaId() {
      const { code, msg, data } = await this.request.get("front/system/config/query")
      if (code !== 200) {
        if (code == 500) {
          return this.$message.error(msg)
        }
        return
      }
      if (!data) {
        return
      }
      // 获取系统名称
      let systemNameItem = data.find(item => item.code == "SYS_NAME")
      this.systemName = systemNameItem.value
      document.title = systemNameItem.value
      this.$store.dispatch('setSystemName', systemNameItem.value)
      // 获取系统区域
      let areaItem = data.find(item => item.type == 3)
      let areaId = areaItem.value.split('_')

      let curId = null
      if (areaId.length == 1) {
        curId = areaId[0]
      } else if (areaId.length == 2) {
        curId = areaId[1]
      }
      this.getPosition(curId)
    },

    /**
     * @Description 获取首页配置信息
     * @Author      YOYO     -             2021-11-25
     */
    async getMapType() {
      const { code, msg, data } = await this.request.get('/front/homepage/findTenantConfig')
      if (code !== 200) {
        if (code == 500) {
          return this.$message.error(msg)
        }
        return
      }
      if (data.mapType == 2) { // 卫星图
        this.satellite = new AMap.TileLayer.Satellite({ zooms: [3, 20] });
        this.satellite.setMap(this.myMap)    
      } /*else {
        this.myMap.setMapStyle('amap://styles/09e4b2809bd2d5e60d4eef9ff7c3140e')
      }*/
      this.mapType = data.mapType
    },

    /**
     * @Description 获取中心坐标及城市
     * @Author      YOYO     -     2021-11-23
     * @param       {[type]} curId [description]
     */
    async getPosition(curId) {
      const { code, msg, data } = await this.request.get(`/front/region/queryRegionById?regionId=${curId}`)

      if (code !== 200) {
        if (code == 500) {
          return this.$message.error(msg)
        }
        return
      } else {
        let loginName = this.loginName == 'jlhw'
        if (data.city) {
          this.position = data.city
          Promise.all([(loginName ? this.getMarkerJLHW() : this.getMarker()), this.initGDMap(data.city, [data.longitude, data.latitude], 2)]).then(() => {
            loginName ? this.processInBatchesAsync() : this.setMarkerInMap()
          })
          // this.initGDMap()
        } else {
          this.position = data.province
          let level = data.id == 999 ? 0 : 1
          Promise.all([(loginName ? this.getMarkerJLHW() : this.getMarker()), this.initGDMap(data.province, [data.longitude, data.latitude], level)]).then(() =>{
            loginName ? this.processInBatchesAsync() : this.setMarkerInMap()
          })
        }
      }
    },
    
    /**
     * @Description 分页请求地图Marker
     * @Author      YOYO     -             2025-10-13
     */
    getMarkerLoop () {
      this.markerPage += 1
    },
    // getMarkerJLHW() {
    //   return new Promise((resolve, rej) => {
    //     this.$axios.get(`${this.baseUrlAddr}/front/device/deviceMapData2`).then(res => {
    //       if (res.status == 200) {
    //         // this.markerList = res.data
    //         this.chunks = this.chunkArray(res.data, 20000)
    //         resolve('获取marker成功')
    //       } else {
    //         rej('获取marker失败')
    //         return this.$message.error(msg)
    //       }
    //     }).catch(error => {
    //       console.error(error)
    //       rej('获取marker失败')
    //     })
    //   })
    // },
    getMarkerJLHW() {
      return new Promise(async (resolve, rej) => {
        // await this.request.get('/front/device/deviceMapData2')
        this.$axios.get(`/front/file/deviceMapData.json`).then(res => {
          if (res.status == 200) {
            // console.log(1144, res.data.data)
            this.markerList = res.data.data
            this.chunks = this.chunkArray(res.data.data, 20000)
            // this.processInBatches(chunks); // 启动处理
            resolve('获取marker成功')
          } else {
            rej('获取marker失败')
            return this.$message.error('文件过大，请刷新重试（勿要频繁刷新）！')
          }
        }).catch(error => {
          console.error(error)
          rej('获取marker失败')
        })
      })
    },
    /**
     * @Description 获取地图扎点
     * @Author      YOYO     -             2021-11-24
     */
    getMarker() {
      return new Promise((resolve, rej) => {
        this.request.post('/front/device/deviceMapData').then(res => {
          if (res.code == 200) {
            this.markerList = res.data
            resolve('获取marker成功')
            // this.init()
          } else if (res.code == 500) {
            rej('获取marker失败')
            return this.$message.error(msg)
          }
        }).catch(error => {
          console.error(error)
          rej('获取marker失败')
        })
      })
    },

    /**
     * @Description 将获取的地图扎点渲染在初始化好的地图上
     * @Author      YOYO - 2021-11-24
     */
    async setMarkerInMap () {
      let self = this
      let markerList = []
      this.markerList.forEach(item => {
        let { id, name, installGps, deviceType, isOnline, isFault, isAlarm } = item

        if (!installGps) return
        let lonlat = installGps.split(',')
        if (!lonlat || !lonlat.length) return

        let iconTemp = [0, 1, 2, 3, 6, 7, 8, 9, 10, 11, 12, 13, 16, 17, 19, 21, 23, 25, 29, 31, 33, 35, 37, 39].indexOf(deviceType) == -1 ? 'Other' : deviceType

        let icon = !isOnline ? `out${iconTemp}` : isFault ? `Yellow${iconTemp}` : isAlarm ? `Red${iconTemp}` : `on${iconTemp}`

        if (isNaN(lonlat[0])) {
          lonlat[0] = 0
        }
        if (isNaN(lonlat[1])) {
          lonlat[1] = 0
        }

        var marker = new AMap.Marker({
          position: new AMap.LngLat(lonlat[0] || 0, lonlat[1] || 0),
          icon: require(`./../../assets/img/back/baiduIcon1/${icon}.png`),
          title: name,
        })
        marker.id = id

        AMap.event.addListener(marker, 'click', function () {
          let temp = self.$refs.info_window
          temp.style.display = 'block'
          self.infoData = item
          self.infoWindowBg = item.isFault ? 'yellow' : item.isAlarm ? 'red' : 'blue'

          self.infoItem = self.getInfoWindowData(temp)

          let { lng, lat } = marker.getPosition()
          self.myMap.panTo([lng, lat])

          setTimeout(() => {
            self.infoItem.open(self.myMap, self.myMap.getCenter())
          }, 400)

        })

        markerList.push(marker)
      })
      // this.myMap.add(markerList)
      // 聚合样式-修改
      var styles = [
        {
          url: "http://webapi.amap.com/theme/v1.3/m1.png",
          size: new AMap.Size(53, 52),
          offset: new AMap.Pixel(-26, -26)
        },
        {
          url: "http://webapi.amap.com/theme/v1.3/m2.png",
          size: new AMap.Size(56, 55),
          offset: new AMap.Pixel(-28, -28)
        },
        {
          url: require('./../../assets/img/bigScreen/m3.png'),
          size: new AMap.Size(66, 65),
          offset: new AMap.Pixel(-33, -33)
        },
        {
          url: "http://webapi.amap.com/theme/v1.3/m4.png",
          size: new AMap.Size(78, 77),
          offset: new AMap.Pixel(-39, -39)
        },
        {
          url: "http://webapi.amap.com/theme/v1.3/m5.png",
          size: new AMap.Size(90, 89),
          offset: new AMap.Pixel(-45, -45)
        }
      ];

      let markerClusterer = new AMap.MarkerClusterer(this.myMap, markerList, { styles, minClusterSize: 60, maxZoom: 17 })

      // this.myMap.setFitView()
    },

    /**
     * @Description 切换地图图层
     * @Author      YOYO - 2021-11-25
     */
    handleChangeMap (i) {
      this.mapActive = i
      if (i == 0) {
        this.satellite.show()
      } else {
        this.satellite.hide()
      }
    },

    /**
     * @description: 信息弹窗
     * @return       {object} infoWindow对象
     */
    getInfoWindowData (temp) {
      var infoWindow = new AMap.InfoWindow({
        content: (() => {
          let box = document.createElement('div')
          box.appendChild(temp)
          return box
        })(),
        isCustom: true,
        anchor: 'bottom-right',
        offset: new AMap.Pixel(0, -10)
      })

      return infoWindow
    },
    // 关闭信息窗口
    handleCloseInfoWindow () {
      this.infoItem && this.infoItem.close()
    },
    // 地图
    /*initMap(position, latitude, longitude, Alarm) {
      this.alarmType = Alarm
      var map = new BMap.Map("map_container");
      map.centerAndZoom(new BMap.Point(latitude, longitude), 11);
      map.addControl(new BMap.MapTypeControl({
        mapTypes: [BMAP_NORMAL_MAP, BMAP_SATELLITE_MAP],
        anchor: BMAP_ANCHOR_TOP_LEFT
      }))
      map.enableScrollWheelZoom(true);
      let that = this
      var bdary = new BMap.Boundary();
      bdary.get(position, function (rs) { //获取行政区域
        //网上查了下，东西经南北纬的范围
        var EN_JW = "180, 90;"; //东北角
        var NW_JW = "-180,  90;"; //西北角
        var WS_JW = "-180, -90;"; //西南角
        var SE_JW = "180, -90;"; //东南角
        //4.添加环形遮罩层
        var bdaryarr;
        var olength = rs.boundaries.length;
        if (olength > 1) {
          var maxindex = 0;
          var maxlength = rs.boundaries[0].length;
          for (var i = 0; i < olength; i++) {
            var inlength = rs.boundaries[i].length;
            if (inlength > maxlength) {
              maxindex = i;
              maxlength = inlength;
            }
          }
          bdaryarr = rs.boundaries[maxindex];
        } else {
          bdaryarr = rs.boundaries[0];
        }
        var formatploy
        if (position == "中国") {
          formatploy = that.chiaData.join(';')
        } else {
          if (bdaryarr) {
            var temp = bdaryarr.split(';');
            formatploy = bdaryarr + ';' + temp[0];
          } else {
            formatploy = null
          }
        }
        if (formatploy != null) {
          var ply1 = new BMap.Polygon(formatploy + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW, {
            strokeColor: "none",
            fillColor: "rgb(30,37,41)",
            fillOpacity: 0.9,
            strokeOpacity: 0
          }); // 建立多边形覆盖物

          map.addOverlay(ply1);
        }
        //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
        //console.log(`formatploy`, formatploy)
        var ply = new BMap.Polygon(formatploy, {
          strokeWeight: 2,
          strokeColor: "rgb(51,204,255)",
          fillColor: ""
        });
        map.addOverlay(ply);
        map.setViewport(ply.getPath()); //调整视野
      });
      // 区域===========================
      map.setMapStyle({
        styleJson: [{
          "featureType": "water",
          "elementType": "all",
          "stylers": {
            "color": "#044161"
          }
        }, {
          "featureType": "land",
          "elementType": "all",
          "stylers": {
            "color": "#091934"
          }
        }, {
          "featureType": "boundary",
          "elementType": "geometry",
          "stylers": {
            "color": "#064f85"
          }
        }, {
          "featureType": "railway",
          "elementType": "all",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "highway",
          "elementType": "geometry",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "highway",
          "elementType": "geometry.fill",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "highway",
          "elementType": "labels",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "arterial",
          "elementType": "geometry",
          "stylers": {
            "color": "#004981",
            "lightness": -39
          }
        }, {
          "featureType": "arterial",
          "elementType": "geometry.fill",
          "stylers": {
            "color": "#00508b"
          }
        }, {
          "featureType": "poi",
          "elementType": "all",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "green",
          "elementType": "all",
          "stylers": {
            "color": "#056197",
            "visibility": "off"
          }
        }, {
          "featureType": "subway",
          "elementType": "all",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "manmade",
          "elementType": "all",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "local",
          "elementType": "all",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "arterial",
          "elementType": "labels",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "boundary",
          "elementType": "geometry.fill",
          "stylers": {
            "color": "#029fd4"
          }
        }, {
          "featureType": "building",
          "elementType": "all",
          "stylers": {
            "color": "#1a5787"
          }
        }, {
          "featureType": "label",
          "elementType": "all",
          "stylers": {
            "visibility": "off"
          }
        }, {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": {
            "color": "#ffffff"
          }
        }, {
          "featureType": "poi",
          "elementType": "labels.text.stroke",
          "stylers": {
            "color": "#1e1c1c"
          }
        }, {
          "featureType": "administrative",
          "elementType": "labels",
          "stylers": {
            "visibility": "on"
          }
        }, {
          "featureType": "road",
          "elementType": "labels",
          "stylers": {
            "visibility": "off"
          }
        }]
      });

      // console.log(`that. this.markerList`, that.markerList)
      var markers = [];
      var pt = null;
      that.markerList.forEach((item, i) => {
        // console.log(`item`, item)
        //          if ( i>that.markerList.length/2) {
        //     pt = new BMap.Point(...item.installGps.split(","));
        //     // markers.push(new BMap.Marker(pt, {icon: myIcon}));
        // } else {
        if (item.installGps) {
          pt = new BMap.Point(...item.installGps.split(","));
          var a
          var myIcon
          if (item.deviceType == 0) {
            // 烟感
            if (item.isOnline) {
              myIcon = new BMap.Icon(require("../../assets/img/back/baiduIcon/onLineYanGan.png"), new BMap.Size(30, 30), {
                // offset: new BMap.Size(10, 25), // 指定定位位置
                // imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
              });
            } else {
              myIcon = new BMap.Icon(require("../../assets/img/back/baiduIcon/outLineYanGan.png"), new BMap.Size(30, 30), {
                // offset: new BMap.Size(10, 25), // 指定定位位置
                // imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
              });
            }
            a = new BMap.Marker(pt, {
              icon: myIcon
            })
          } else if (item.deviceType == 1) {
            // 可燃气体
            if (item.isOnline) {
              myIcon = new BMap.Icon(require("../../assets/img/back/baiduIcon/onLineKeRanQi.png"), new BMap.Size(30, 30), {
                // offset: new BMap.Size(10, 25), // 指定定位位置
                // imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
              });
            } else {
              myIcon = new BMap.Icon(require("../../assets/img/back/baiduIcon/outLineKeRanQi.png"), new BMap.Size(30, 30), {
                // offset: new BMap.Size(10, 25), // 指定定位位置
                // imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
              });
            }
            a = new BMap.Marker(pt, {
              icon: myIcon
            })
          } else {
            if (item.isOnline) {
              //其他离线
              myIcon = new BMap.Icon(require("../../assets/img/back/baiduIcon/onLineOther.png"), new BMap.Size(30, 30), {
                // offset: new BMap.Size(10, 25), // 指定定位位置
                // imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
              });
              // a = new BMap.Marker(pt)
            } else {
              myIcon = new BMap.Icon(require("../../assets/img/back/baiduIcon/outLineOther.png"), new BMap.Size(30, 30), {
                // offset: new BMap.Size(10, 25), // 指定定位位置
                // imageOffset: new BMap.Size(0, 0 - 10 * 25) // 设置图片偏移
              });
            }
            a = new BMap.Marker(pt, {
              icon: myIcon
            })
          }
          if (this.alarmType == 'Alarm') {
            var point = new BMap.Point(latitude, longitude);
            map.centerAndZoom(point, 12);

            const option = {
              position: point,
              offset: new BMap.Size(-40, -40),
            };

            const valueLabel = new BMap.Label(
              "<div class='classScale' style='display:flex; justify-content: center; align-items: center; width:80px;height:80px;border-radius:50%; opacity: 0.5;'></div><div class='classScale1' style='position:relative; top: -80px;width:80px;height:80px;border-radius:50%; opacity: 0.5;'></div>",
              option);
            valueLabel.setStyle({
              border: 'none',
              backgroundColor: 'RGBA(0,0,0,0)',
            });
            map.addOverlay(valueLabel);
          }
          markers.push(a);
          a.addEventListener("click", function (e) {
            var p = e.target;
            var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
            // 创建信息窗口对象
            var opts = {
              width: 250, // 信息窗口宽度
              height: 280, // 信息窗口高度
              enableMessage: true //设置允许信息窗发送短息
            };
            let str = ''
            str = `<h4 class="title" style="color:#009688">${item.userName}(C19083100288)</h4><br />` +
              `<div class="item">
                            <span class="logo"><i class="el-icon-s-flag" style="width:20px;color:#51AAA2"></i></span>
                            <span class="label" style="color:#7e7b7a;width:100px">管理方：</span>
                            <span class="value" style="color:#000">${item.orgName}</span>
                          </div><br />` +
              `<div class="item">
                            <span class="logo"><i class="el-icon-position" style="width:20px;color:#E7A485"></i></span>
                            <span class="label" style="color:#7e7b7a;width:100px">安装位置：</span>
                            <span class="value" style="color:#000">${item.installLocation}</span>
                          </div><br />` +
              `<div class="item">
                            <span class="logo"><i class="el-icon-location-information" style="width:20px;color:#DCBE75"></i></span>
                            <span class="label" style="color:#7e7b7a;width:100px">IMEI：</span>
                            <span class="value" style="color:#000">${item.imei}</span>
                          </div><br />` +
              `<div class="item">
                            <span class="logo"><i class="el-icon-time" style="width:20px;color:#8B966C"></i></span>
                            <span class="label" style="color:#7e7b7a;width:100px">安装时间：</span>
                            <span class="value" style="color:#000">${item.installTime}</span>
                          </div><br />` +
              `<div class="item">
                            <span class="logo"><i class="el-icon-video-play" style="width:20px;color:#379D94"></i></span>
                            <span class="label" style="color:#7e7b7a;width:100px">注册时间：</span>
                            <span class="value" style="color:#000">${item.registTime}</span>
                          </div><br />` +
              `<div class="item">
                            <span class="logo"><i class="el-icon-video-pause" style="width:20px;color:#75A6BB"></i></span>
                            <span class="label" style="color:#7e7b7a;width:100px">创建时间：</span>
                            <span class="value" style="color:#000">${item.createTime}</span>
                          </div><br />`
            var infoWindow = new BMap.InfoWindow(
              str, opts);
            //开启信息窗口
            map.openInfoWindow(infoWindow, point);
          });
        }

        // }
      })

      var markerClusterer = new BMapLib.MarkerClusterer(map, {
        markers: markers,
        // styles: st
      });
      var TextIconOverlay = new BMapLib.TextIconOverlay();

      //点聚合=====================
      map.setMapType(that.mapType * 1 == 1 ? BMAP_NORMAL_MAP : BMAP_SATELLITE_MAP, () => {})
    },*/
    // 初始化地图-画边缘线
    initGDMap (city, center, level) {
      let self = this
      // let zoomTemp = [4, 7, 9]
      this.isMap = true

      this.timmer && clearTimeout(this.timmer)
      this.timmer = setTimeout(() => {
        this.isMap = false
      }, 10000)
      
      return new Promise((resolve, rej) => {
        // if (level == 0) {
        var map = new AMap.Map('map_box', {
          // center: level == 0 ? [103.489327,38.915885] : center,
          // zoom: zoomTemp[level],
          expandZoomRange: true,
          zooms: [4,20],
          center: [103.489327,38.915885]
        });
        // map.setMapStyle('amap://styles/9ecbf90698448c57745099c4e8a15ac6')
        // map.setMapStyle('amap://styles/9b047693594624ca089db5a907799437')
        map.setMapStyle('amap://styles/2839a6f7be2bb918c1200c77b3515390')
        self.myMap = map
        self.getMapType()
        resolve('初始化地图成功')
        new AMap.DistrictSearch({ extensions:'all', subdistrict: 1 }).search(city, (status,result) => {
            // 外多边形坐标数组和内多边形坐标数组
            var outer = [
              new AMap.LngLat(-360,90,true),
              new AMap.LngLat(-360,-90,true),
              new AMap.LngLat(360,-90,true),
              new AMap.LngLat(360,90,true),
            ];
            var holes = result.districtList[0].boundaries

            var pathArray = [ outer ]
            self.myMap.setFitView(city)
            pathArray.push.apply(pathArray,holes)

            var polygon = new AMap.Polygon( {
              pathL:pathArray,
              strokeColor: '#00eeff',
              strokeWeight: 2,
              fillColor: '#020C24',
              fillOpacity: 0.9
            });
            polygon.setPath(pathArray);
            self.myMap.add(polygon)
            // var bounds = result.districtList[0].boundaries;

            // 假装描边
            let lineArr = []
            // let mask = []
            for(var i =0; i< holes.length; i+=1){
              let line = new AMap.Polyline({ path: holes[i] })
              lineArr.push(line)
              // mask.push([holes[i]])
            }
            // this.myMap.setMask(mask)
            if (level == 0) {
              this.myMap.setZoom(4); 
              this.myMap.setCenter([103.489327,38.915885]); 
            } else {
              this.myMap.setFitView(lineArr)
            }
            this.isMap = false
            // self.myMap = map
        })
        // }
        /*this.isMap = true
        // 省市区地图
        var opts = {
          extensions: 'all',
          subdistrict: 1
        };
        //利用行政区查询获取边界构建mask路径
        var district = new AMap.DistrictSearch(opts);
        district.search(city, function(status, result) {
          var bounds = result.districtList[0].boundaries;
          var mask = []
          for(let i =0; i<bounds.length; i+=1){
            mask.push([bounds[i]])
          }
          // 初始化地图
          var map = new AMap.Map('map_box', {
            mask,
            center,
            viewMode:'3D',
            pitch: 0,
            zoom: zoomTemp[level],
            expandZoomRange: true,
            zooms: [4,20]
          });
          map.setMapStyle('amap://styles/09e4b2809bd2d5e60d4eef9ff7c3140e')

          //获取首页配置信息
          self.getMapType()
          self.isMap = false

          // 地图图层工具
          // self.isShowChange = true

          //添加高度面
          var object3Dlayer = new AMap.Object3DLayer({zIndex:1});
          map.add(object3Dlayer)
          var wall = new AMap.Object3D.Wall({
            path: bounds,
            height: -15000,
            color: '#0088ffcc'
          });
          wall.transparent = true
          object3Dlayer.add(wall)
          // //添加描边
          for(var i =0;i<bounds.length;i++){
            new AMap.Polyline({
              path:bounds[i],
              strokeColor:'#99ffff',
              strokeWeight:2,
              map
            })
          }

          self.myMap = map
          resolve('初始化地图成功')
        });*/
      })
    },
    toBack() {
      const { href } = this.$router.resolve({
        name: 'equipmentM'
      })
      window.open(href, "_blank")
    },
    // 退出
    logOut() {
      this.$confirm("是否退出该账户?", "退出登录提示", {
        confirmButtonText: "退出",
        cancelButtonText: "取消",
        type: "error",
        center: true
      })
      .then(() => {
        this.request.get("/front/auth/logout").then((data) => {
          ////console.log(data);
          // debugger
          if (data.code == 200) {
            this.msg.success("退出登录成功！");
            this.storage.setSession("login", false)
            // sessionStorage.setItem('alarmList', null)
            this.resetSetItem('alarmList', null, 7)
            this.$router.push("/login")
          } else if (data.code == 500) {
            if (data.msg) {
              this.msg.warn("退出登录失败，请联系管理员！");
            } else {
              this.msg.warn("Session过期，请重新登录!")
              this.$router.push("/login");
            }
          }
        });
      })
      .catch(() => {
        this.msg.info("已取消退出登录");
      });
    },
    // Echarts大屏
    openBigScreen(id) {

      this.bigScreenEcharts.item = {
        ...this.items.find(item => item.id == id)
      }
      this.bigScreenEcharts.show = true
    },
    closeDialog() {
      this.bigScreenEcharts.show = false
    },
    tempV () {
      this.isVideo = true
      // let src = 'https://live-3a16.aliplus.com/live/SI0rjiaVfIuEC_npncdfymFrlfYP-a86XaQsjU7mwsI_1.m3u8?token=de80eedd5a9a4c3c92d88ed0bbd42c16&session=f911bc2931b144dc9491a34bd8859a04'
      let src = 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'
      let index = this.i
     this.i += 1
      let len = this.videoItemConfig.length
      // console.log(112233, len)
      // console.log(2233, this.videoItemConfig)
      this.videoItemConfig.push({
        videoContainerId: `videoContainer${index}`,
        videoId: `video${index}`,
      })

      this.initVideo(src, len)
    },
    // 打开关闭报警
    handleChangeAlarm (e) {
      this.isAlarmShow = e
      if (e) {
        // let alarmList = JSON.parse(window.localStorage.getItem('alarmList'))
        let alarmList = this.resetGetItem('alarmList')
        this.alarmList = alarmList

        this.createWebSockets()
      } else {
        this.alarmList = []
        // sessionStorage.setItem('alarmList', JSON.stringify([]))
        this.resetSetItem('alarmList', JSON.stringify([]), 7)

        const { ws } = this
        ws && ws.close()

        window.speechSynthesis.cancel()
      }
    },
    /**
     * @Description 关闭某个报警弹窗
     * @Author      YOYO     -             2021-11-25
     */
    handleCloseAlarm (i) {
      let alarmList = [ ...this.alarmList ]
      this.audioDemo && this.audioDemo.pause()
      alarmList.splice(i, 1)
      this.alarmList = alarmList
      // sessionStorage.setItem('alarmList', JSON.stringify(alarmList))
      this.resetSetItem('alarmList', JSON.stringify(alarmList), 7)
      window.speechSynthesis.cancel()
    },
    /**
     * @Description 打开某个报警弹窗
     * @Author      YOYO     -             2021-11-25
     */
    handleShowBox (item) {
      let { installGps, deviceId } = item

      if (!installGps) return this.$message({ message: '没有坐标哦！', type: 'warning' });

      let lonlat = installGps.split(',')
      if (!lonlat || !lonlat.length) return      

      let temp = this.$refs.info_window
      temp.style.display = 'block'

      this.infoItem = this.getInfoWindowData(temp)

      this.myMap.panTo(lonlat)
      this.myMap.setZoom(18);

      setTimeout(() => {
        this.infoItem.open(this.myMap, this.myMap.getCenter())
      }, 800)

      // 显示弹框内容
      let marker = this.markerList.find(({ id }) => id == deviceId)
      this.infoData = marker || []

      // let { lng, lat } = marker.getPosition()
    },
    // 报警弹窗-处理
    handleShowDealBox (item, i) {
      // console.log(item)
      this.policeContent = item.content
      this.isDealalarmShow = true
      this.alarmId = item.alarmId
      this.alarmIndex = i
    },
    
    /**
     * @description: 初始化视频
     * @param {String} 视频链接
     * @param {Number} 选中要播放视频的框的索引
     * @return {undefined} 无返回值
     */
    initVideo (src, videoSelectIndex) {
      if (this.videoItemConfig[videoSelectIndex].videoInstance) this.destorySinglePlayer(videoSelectIndex)

      let videoContainerId = this.videoItemConfig[videoSelectIndex].videoContainerId
      let videoId = this.videoItemConfig[videoSelectIndex].videoId

      this.$nextTick(() => {
        document.getElementById(videoContainerId).innerHTML = '<video id=' + videoId + " class='video-js videoItem vjs-default-skin' preload='auto' autoplay controls muted><source src=" + src + " type='application/x-mpegURL' /></video>"

        // eslint-disable-next-line no-undef
        this.videoItemConfig[videoSelectIndex].videoInstance = videojs(videoId, {}, function onPlayerReady () {
          this.hotkeys({
            volumeStep: 0.1,
            seekStep: 5,
            enableVolumeScroll: false,
            enableModifiersForNumbers: false,
          })
          this.play()
          this.on('ended', function () {
            console.log('ended, video js')
          })
        })
      })
    },
    /**
     * @description: 销毁单个视频实例
     * @param {Number} 视频实例索引
     * @return {undefined} 无返回值
     */
    destorySinglePlayer (index) {
      if (this.videoItemConfig[index].videoInstance) {
        this.videoItemConfig[index].videoInstance.dispose()
        this.videoItemConfig[index].videoInstance = null
      }

      this.videoItemConfig.splice(index, 1)

      if (this.videoItemConfig.length <= 0) {
        this.isVideo = false
      }

      // document.getElementById(this.videoItemConfig[index].videoContainerId).innerHTML = "<div class='noVideo'><i class='el-icon-video-camera iconbofang'></i><span class='noVideoText'>无播放视频</span></div>"
    },
    /**
     * @Description 拖动位置
     * @Author      YOYO     - 2022-03-24
     * @param       {Object} e [事件对象]
     * @param       {number} i [下标]
     * @return      {[type]}   [description]
     */
    handleMousedown (e, id) {
      let { x, y, l, t } = this.dragObj

      let dv = this.$refs[`li_${id}`][0]
      let ul = this.$refs.ul
      // 获取x坐标和y坐标
      x = e.clientX
      y = e.clientY

      //获取左部和顶部的偏移量
      l = dv.offsetLeft;
      t = dv.offsetTop;

      //开关打开
      this.isDown = true

      //设置样式
      dv.style.cursor = 'move'

      //鼠标移动
      window.onmousemove = (e) => {
        if (this.isDown == false) return

        //计算移动后的左偏移量和顶部的偏移量
        var nl = e.clientX - (x - l)
        var nt = e.clientY - (y - t)

        dv.style.left = nl + 'px'
        dv.style.top = nt + 'px'
      }
      //鼠标抬起事件
      dv.onmouseup = () => {
        //开关关闭
        this.isDown = false
        dv.style.cursor = 'default'
      }
      //鼠标移动结束事件
      dv.onmouseover = (e) => {
        if (this.isDown == false) return

        this.isDown = false
        dv.style.cursor = 'move'
      }
    },
    handleVoice (e) {
      window.localStorage.setItem('isMp3', e)
      if (e) {
        this.playAudio()
      } else {
        let msg = '您好，现在开始测试语音是否能正常播报'
        this.speaking(msg)
      }
    },
    handleReload () {
      this.$router.go(0)
    },
    // 注意事项
    handleAttention () {
      this.isShowAttention = true
    },
    // 处理报警弹窗-取消
    cancelHandle() { //取消
      this.isDealalarmShow = false
      this.form = { type: '', describe: '' }
    },
    // 处理报警弹窗-提交
    confirmHandle() {
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        let { type, describe } = this.form
        let params = { 
          id: this.alarmId,
          type,
          describe,
          imgNames: ''
        }
        // console.log(234234, params)
        this.loadingDeal = true
        this.request.postParamsData("/front/alarm/record/handle", params).then(rs => {
          this.loadingDeal = false
          if (rs.code === 200) {
            this.msg.success('处理成功')
            this.cancelHandle()
            this.handleCloseAlarm(this.alarmIndex)
          } else if (rs.code == 500) {
            this.msg.warn(rs.msg);
          }
        })
      })
    },
  },
  destroyed () {
    const { ws } = this
    ws && ws.close()
  }
}
</script>

<style lang="scss" scoped>
.screen {
  width: 100%;
  height: 100%;
  overflow: auto;
  // background-color: #0C1A35;
  // background: url(../../assets/img/bigScreen/bg.jpg) no-repeat;

  .rain {
    border: 1px solid red;
    position:fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
  }

  .header-top {
    width: 100%;
    height: 60px;
    background: url(../../assets/img/bigScreen/header.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    z-index: 99;
    .title {
      font-family: "HYWenHEI";
      text-align: center;
      font-size: 28px;
      line-height: 60px;
      color: #00E5FF;

      background-image: linear-gradient(0deg, #0284D1 0%, #00E5FF 100%);
      background-clip: text;
      text-fill-color: transparent;
      // 前缀
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-image: -webkit-linear-gradient(bottom, #0284D1, #00E5FF);
    }
    .header-left {
      position: absolute;
      bottom: 5px;
      left: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #02D9FD;
      span {
        margin-right: 10px;
      }
      .normal {
        display: inline;
        color: #08BB80;
        margin-left: 10px;
        i {
          display: inline-block;
          width: 6px;
          height: 6px;
          vertical-align: 2px;
          background-color: #08BB80;
          border-radius: 50%;
          margin-right: 7px;
        }
      }
      .abNormal {
        display: inline;
        color: #999B9E;
        margin-left: 10px;
        i {
          display: inline-block;
          width: 6px;
          height: 6px;
          vertical-align: 2px;
          background-color: #999B9E;
          border-radius: 50%;
          margin-right: 7px;
        }
      }
      
    }
    .header-right {
      position: absolute;
      right: 15px;
      bottom: 5px;
      font-size: 14px;
      color: #02D9FD;
      .p-div {
        display: inline-block;
      }
      p {
        display: inline-block;
        margin-right: 15px;
        cursor: pointer;
        i {
          vertical-align: -2px;
          font-size: 20px;
        }
      }

      .alarm-switch {
        span {
          vertical-align: -2px;
          margin-left: 5px;
        }
      }
      .voice {
        margin-right: 15px;
        img {
          width: 19px;
          cursor: pointer;
          vertical-align: -4px;
        }
      }
      .myIcon {
        font-size: 18px;
        cursor: pointer;
        vertical-align: -2px;
      }
    }
  }

  .total-center {
    position: absolute;
    top: 68px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 11;
    color: #fff;
    width: 840px;
    li {
      // min-width: 110px;
      width: 132px;
      height: 74px;
      display: inline-block;
      background: url(../../assets/img/bigScreen/total-box.png) no-repeat;
      background-size: 100% 100%;
      margin-right: 4px;
      margin-left: 4px;
      vertical-align: top;
      img {
        width: 35px;
        margin-left: 10px;
        margin-right: 5px;
      }
      .right {
        vertical-align: -15px;
        margin-top: 12px;
        display: inline-block;
        font-size: 14px;
        color: #02D9FD;
        text-align: center;
        p:first-child {
          max-width: 82px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .num {
          font-size: 18px;
          font-family: 'PMZD';
          margin-top: 5px;
        }
      }
      .ponter5 {
        cursor: pointer;
      }
    }
  }

  // padding-top: auto;
  // .BMap_noprint {
  //   z-index: 100;
  //   margin-top: 500px;
  // }

  .space {
    height: 52px;
    box-sizing: border-box;
    // background-color: rgba(77, 120, 167,.8)
    background-color: #1e2639;
    // background-color: ;
  }

  #map_container {
    width: 100%;
    height: 100%;
    // .BMap_noprint anchorTL

  }
  #map_box {
    width: 100%;
    height: 100%;
    margin-top: -60px;
  }
  .loading {
      width: 150px;
      height: 10px;
      margin: 0 auto;
      margin-top:100px;
      span{
        display: inline-block;
        width: 10px;
        height: 100%;
        margin-right: 5px;
        border-radius: 50%;
        background: #13E1F1;
        -webkit-animation: load 1.04s ease infinite;
        &:last-child{
          margin-right: 0px; 
        }

        &:nth-child(1){
          -webkit-animation-delay:0.13s;
        }
        &:nth-child(2){
          -webkit-animation-delay:0.26s;
        }
        &:nth-child(3){
          -webkit-animation-delay:0.39s;
        }
        &:nth-child(4){
          -webkit-animation-delay:0.52s;
        }
        &:nth-child(5){
          -webkit-animation-delay:0.65s;
        }
      }
    }
    
  
  .map-change {
    position: absolute;
    bottom: 15px;
    right: 27%;
    width: 152px;
    height: 83px;
    background: url('../../assets/img/bigScreen/map_layer.png') no-repeat;
    background-size: 100% 100%;
    li {
      cursor: pointer;
      width: 58px;
      height: 58px;
      display: inline-block;
      margin-left: 12px;
      margin-top: 9px;
      text-align: center;
      line-height: 58px;
      font-size: 12px;
      background: url('../../assets/img/bigScreen/layer_back.png') no-repeat;
      background-size: 100% 100%;
      color: #687082;
      transition: .5s;
      &.active {
        color: #fff;
        background: url('../../assets/img/bigScreen/layer_back_active.png') no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .info-window {
    border: 1px solid transparent;
    width: 289px;
    height: 301px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    &.red {
      background-image: url('../../assets/img/bigScreen/red.png');
      color: #FF002A;
    }
    &.blue {
      color: #21F7FC;
      background-image: url('../../assets/img/bigScreen/blue.png');
    }
    &.yellow {
      background-image: url('../../assets/img/bigScreen/yellow.png');
      color: #FFCE38;
    }
    .box {
      border: 1px solid transparent;
      width: 233px;
      height: 278px;
      margin-left: 9px;
      margin-top: 12px;
      font-size: 12px;
      box-size: border-box;
      h4 {
        height: 32px;
        line-height: 32px;
        font-size: 13px;
        background-image: linear-gradient(to right, rgba(66, 231, 255, 0.1), rgba(66, 231, 255, 0));
        margin-top: 10px;
        >span {
          margin-left: 10px;
          display: inline-block;
          width: calc(100% - 42px);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .close {
          float: right;
          // border: 1px solid #145E6C;
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          margin-right: 10px;
          margin-top: 5px;
          font-size: 20px;
          cursor: pointer;
        }
      }
      p {
        margin: 15px 20px;
        span {
          &:first-child {
            display: inline-block;
            width: 60px;
          }
          &:last-child {
            color: #fff;
          }
        }
      }
      .position {
        span:last-child {
          display: inline-block;
          vertical-align: top;
          width: calc(100% - 62px);
          max-height: 50px;
          overflow: hidden;
        }
      }
      .orgName {
        span:last-child {
          display: inline-block;
          vertical-align: top;
          width: calc(100% - 62px);
          overflow: hidden;
          text-ovflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .alarm-list {
    // border: 1px solid red;
    position: absolute;
    bottom: 0px;
    // top: 150px;
    // right: 20px;
    right: 25%;
    z-index: 999;
    width: 260px;
    max-height: 80%;
    overflow-y: auto;
    overflow-x: hidden;
    transition: .8s;
    .alarm-item {
      width: 260px;
      min-height: 161px;
      color: #fff;
      background: url('../../assets/img/bigScreen/alarm.png') no-repeat;
      // background-color: rgba(222, 2, 41, 0.2);
      background-size: 100% 100%;
      cursor: pointer;
      transition: .8s;
      opacity: 0.9;
      .item {
        padding: 10px 15px 25px;
        color: #FC2121;
        h4 {
          height: 28px;
          line-height: 28px;
          font-size: 14px;
          background-image: linear-gradient(to right, rgba(222, 2, 41, 0.2), rgba(222, 2, 41, 0));
          margin-top: 15px;
          font-weight: bold;
          >span {
            margin-left: 10px;
          }
          .close {
            float: right;
            border: 1px solid rgba(252, 33, 33, .6);
            width: 16px;
            height: 16px;
            line-height: 16px;
            text-align: center;
            margin-right: 10px;
            margin-top: 5px;
          }
        }
        p {
          margin: 10px 15px;
          font-size: 12px;
          span {
            &:first-child {
              display: inline-block;
              padding-right: 10px;
              // width: 60px;
            }
            &:last-child {
              color: #fff;
              word-wrap: break-word;
            }
          }
        }
        .btn-box {
          margin: 0 auto;
          height: 15px;
          line-height: 10px;
          text-align: center;
          // margin-bottom: 10px;
          margin-top: 10px;
          padding: 10px 0;
          cursor: pointer;
          border-top: 1px solid rgba(252, 33, 33, .6);
          font-size: 13px;
          &.disable {
            span:first-child, span:nth-of-type(2) {
              color: #ccc;
              cursor: not-allowed;
            }
          }
          span {
            display: inline-block;
            width: calc(55% - 25px);
            color: #FC2121;
            font-weight: bold;
            border-right: 1px solid rgba(252, 33, 33, .6);
            &:last-child {
              border-right: none;
            }
          }
        }
      }
    }
    &::-webkit-scrollbar {
      width: 0px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0);
      background: rgba(2,217,253,0.5);
    }
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,1);
      border-radius: 0;
      background: rgba(0,0,0,0.5);
    }
  }

  .echartsLeft {
    // top: 30px;
    left: 20px;
  }

  .echartsRight {
    position: absolute;
    right: 20px;
  }

  .echartsLeft,
  .echartsRight {
    position: absolute;
    top: 70px;
    bottom: 5px;
    width: 24%;
    box-sizing: border-box;
    // overflow: hidden;

    .item {
      height: 33.3%;
      min-height: 180px;
      position: relative;
      padding: 8px 0;
      box-sizing: border-box;

      .chartItemBox {
        // border: 1px solid red;
        height: 100%;
        width: 100%;
        // border: 1px solid rgba(39, 79, 121, 0.9);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.9);
        // background-color: rgba(29, 55, 82, 0.85);
        box-sizing: border-box;
        position: relative;

        h4 {
          width: 121px;
          height: 30px;
          position: absolute;
          top: -10px;
          left: 50%;
          margin-left: -60.5px;
          color: #02D9FD;
          text-align: center;
          line-height: 30px;
          font-size: 14px;
          background: url('../../assets/img/bigScreen/card-head.png') no-repeat;
          background-size: 100% 100%;
        }

        &>div {
          padding-top: 24px;
          box-sizing: border-box;
        }
      }

      // .btn {
      //   position: absolute;
      //   top: 7%;
      //   right: 1%;
      //   cursor: pointer;

      //   i {
      //     font-size: 20px;
      //     color: #fff;

      //     text-shadow: 0 0 0 var(--monitorBorder, #3beff0), 0 0 4px var(--monitorBorder, #3beff0), 0 0 0 var(--monitorBorder, #3beff0), 0 0 4px var(--monitorBorder, #3beff0);

      //   }

      //   .el-icon-rank:before {
      //     transform: rotate(45deg);
      //     content: "\e6d1";
      //   }
      // }
    }
  }

  .top {
    // position: absolute;
    // height: 50px;
    // line-height: 50px;
    // right: 0;
    // width: 100%;
    // z-index: 10;
    // display: flex;
    // border-bottom: 1px solid rgba(39, 79, 121, 0.9);
    // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
    // background-color: rgba(29, 55, 82, 0.85);

    // .title {
    //   color: #fff;
    //   width: 100%;
    //   text-align: center;
    //   font-size: 20px;
    //   font-weight: bold;
    //   letter-spacing: 2px;
    // }

    // .right {
    //   position: absolute;
    //   right: 0;
    //   font-size: 22px;
    //   color: #fff;

    //   .timeNow {
    //     float: right;
    //     font-size: 14px;
    //     margin-right: 10px;
    //     letter-spacing: 1px;
    //   }

    //   i {
    //     float: right;
    //     height: 50px;
    //     line-height: 50px;
    //     padding-right: 20px;
    //     cursor: pointer;
    //   }

    // }
  }

  .dragCon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .mainCenter {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 68px;
    width: 500px;
    height: 100px;
    z-index: 11;
    display: flex;
    color: #fff;
    border: 1px solid rgba(39, 79, 121, 0.9);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
    background-color: rgba(29, 55, 82, 0.85);

    li {
      flex: 1;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      height: 100%;
      text-align: center;
      overflow: hidden;

      .centerTop {
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        margin-top: 20px;
      }

      .centerBottom {
        height: 40px;
        line-height: 40px;
        font-size: 30px;
      }

    }
  }
}
</style>
<style lang="scss">
.screen {
  // background-color: #020C24;
  .amap-layers canvas {
    // background-color: #020C24;
    // background: url(../../assets/img/bigScreen/bg.jpg) no-repeat;
  }
  .el-switch__core:after {
    background-color: #02D9FD;
  }
  .el-switch {
    .el-switch__core {
      border-color: #02D9FD!important;
    }
  }
  .anchorBL {
    display: none;
  }

  .mapDialog {
    .item {
      height: 10px;
      line-height: 10px;
    }
  }

  .BMap_noprint {
    inset: auto auto 20px 27% !important;
  }

  .video-list {
    position: absolute;
    bottom: 10px;
    left: 26%;
    width: 380px;
    height: 220px;
    z-index: 999;
    .video-box {
      border: 2px solid #0A66DE;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #343434;
      border-radius: 5px;
      >h5 {
        position: absolute;
        top:0;
        left: 0;
        width: calc(100% - 20px);
        line-height: 25px;
        background-color: rgba(10,102,222,.4);
        color: #efefef;
        padding-left: 20px;
      }
      .icon-close {
        color: #efefef;
        font-size: 22px;
        position: absolute;
        right: 5px;
        top: 2px;
        cursor: pointer;
        z-index: 9999;
      }
      .video-box-item {
        width: 100%;
        height: 100%;
        transition: all 0.5s;
        .noVideo {
          text-align: center;
          // border: 1px solid red;
          margin-top: 20%;
          .iconbofang {
            font-size: 40px;
            color: #dfdfdf;
          }

          .noVideoText {
            display: block;
            font-size: 16px;
            color: #dfdfdf;
          }
        }
        .video-js {
          width: 100%;
          height: 100%;

          .vjs-tech {
            width: 100%;
            height: 100%;
            pointer-events: none;
          }

          .vjs-control-bar {
            .vjs-play-control {
              display: none;
            }
          }
        }
      }
    }
  }
  .deal-dialog {
    .el-dialog__header {
      padding: 10px 20px;
    }
    .drawerFoot {
      text-align: right;
    }
  }

  .attention-box {
    height: 600px;
    overflow: auto;
    p {
      width: 95%;
      margin: 0 auto;
      padding: 10px 5px;
      border: 2px dashed orange;
      // background-color: orange;
      // color: orange;
      border-radius: 2px;
      margin-bottom: 10px;
      font-weight: bold;
      letter-spacing: 2px;
      line-height: 25px;
      color: #333;
      i {
        color: orange;
        font-size: 20px;
        margin-right: 5px;
        margin-left: 5px;
        vertical-align: middle;
      }
    }
    img {
      width: 740px;
    }
  }
  .editPwdDialogTitle {
    font-size: 14px;
    color: red;
    vertical-align: middle;
    i {
      font-size: 18px;
      margin-right: 5px;
      vertical-align: middle;
    }
  }
}
.screen-test-box {
  // width: 260px;
  height: 80px;
  padding: 20px 30px;
  p {
    margin-top: 10px;
    font-size: 12px;
  }
}
.amap-logo, .amap-copyright {
  display: none!important;
}

@keyframes scale {
  0% {
    transform: scale(0);
    background: #ff0000;
  }

  10% {
    transform: scale(0.1);
    background: #ff1d1d;
  }

  20% {
    transform: scale(0.2);
    background: #ff3939;
  }

  30% {
    transform: scale(0.3);
    background: #ff5e5e
  }

  40% {
    transform: scale(0.4);
    background: #ff7d7d;
  }

  50% {
    transform: scale(0.5);
    background: #ff9c9c;
  }

  60% {
    transform: scale(0.6);
    background: #ffb3b3;
  }

  70% {
    transform: scale(0.7);
    background: #ffcece;
  }

  80% {
    transform: scale(0.8);
    background: #ffeeee;
  }

  100% {
    transform: scale(0.9);
    background: #fff2f2;
  }
}

@keyframes scale1 {
  0% {
    transform: scale(0);
    background: #ff0000;
  }

  10% {
    transform: scale(0.1);
    background: #ff1d1d;
  }

  20% {
    transform: scale(0.2);
    background: #ff3939;
  }

  30% {
    transform: scale(0.3);
    background: #ff5e5e
  }

  40% {
    transform: scale(0.4);
    background: #ff7d7d;
  }

  50% {
    transform: scale(0.5);
    background: #ff9c9c;
  }

  60% {
    transform: scale(0.6);
    background: #ffb3b3;
  }

  70% {
    transform: scale(0.7);
    background: #ffcece;
  }

  80% {
    transform: scale(0.8);
    background: #ffeeee;
  }

  100% {
    transform: scale(0.9);
    background: #fff2f2;
  }
}

.classScale {
  animation: scale 2s linear infinite normal;
}

.classScale1 {
  animation: scale1 2s 1s linear infinite normal;
}

// @keyframes shakeX {
//   from,
//   to {
//     -webkit-transform: translate3d(0, 0, 0);
//     transform: translate3d(0, 0, 0);
//   }

//   10%,
//   30%,
//   50%,
//   70%,
//   90% {
//     -webkit-transform: translate3d(-8px, 0, 0);
//     transform: translate3d(-8px, 0, 0);
//   }

//   20%,
//   40%,
//   60%,
//   80% {
//     -webkit-transform: translate3d(8px, 0, 0);
//     transform: translate3d(8px, 0, 0);
//   }
// }
// @-webkit-keyframes shakeX {
//   from,
//   to {
//     -webkit-transform: translate3d(0, 0, 0);
//     transform: translate3d(0, 0, 0);
//   }

//   10%,
//   30%,
//   50%,
//   70%,
//   90% {
//     -webkit-transform: translate3d(-8px, 0, 0);
//     transform: translate3d(-8px, 0, 0);
//   }

//   20%,
//   40%,
//   60%,
//   80% {
//     -webkit-transform: translate3d(8px, 0, 0);
//     transform: translate3d(8px, 0, 0);
//   }
// }
// .animate__shakeX {
//   -webkit-animation: shakeX .5s linear 1;
//   animation: shakeX .5s linear 1;
// }

@-webkit-keyframes bounceInRight {
  from,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    -webkit-transform: translate3d(3000px, 0, 0) scaleX(3);
    transform: translate3d(3000px, 0, 0) scaleX(3);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(-25px, 0, 0) scaleX(1);
    transform: translate3d(-25px, 0, 0) scaleX(1);
  }

  75% {
    -webkit-transform: translate3d(10px, 0, 0) scaleX(0.98);
    transform: translate3d(10px, 0, 0) scaleX(0.98);
  }

  90% {
    -webkit-transform: translate3d(-5px, 0, 0) scaleX(0.995);
    transform: translate3d(-5px, 0, 0) scaleX(0.995);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@keyframes bounceInRight {
  from,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    -webkit-transform: translate3d(3000px, 0, 0) scaleX(3);
    transform: translate3d(3000px, 0, 0) scaleX(3);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(-25px, 0, 0) scaleX(1);
    transform: translate3d(-25px, 0, 0) scaleX(1);
  }

  75% {
    -webkit-transform: translate3d(10px, 0, 0) scaleX(0.98);
    transform: translate3d(10px, 0, 0) scaleX(0.98);
  }

  90% {
    -webkit-transform: translate3d(-5px, 0, 0) scaleX(0.995);
    transform: translate3d(-5px, 0, 0) scaleX(0.995);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.animate__bounceInRight {
  -webkit-animation: bounceInRight 1s linear 1;
  animation: bounceInRight 1s linear 1;
}

@-webkit-keyframes load{
  0%{
      opacity: 1;
  }
  100%{
      opacity: 0;
  }
}
</style>
